// UL101 + acoustic camera combination kits (sold as single P/Ns through Barfield, AvionTEq and CTRL direct).
const UL101_IMAGE = '/images/img_0291.jpeg';
const H6_IMAGES = [
  'https://static.wixstatic.com/media/571718_587034860df449119866a3f97c96fcce~mv2.png/v1/fill/w_720,h_547,al_c,q_85,enc_auto/571718_587034860df449119866a3f97c96fcce~mv2.png',
  'https://static.wixstatic.com/media/571718_80291b29d1284784bc721c034ca1c2cb~mv2.png/v1/fill/w_720,h_583,al_c,q_85,enc_auto/571718_80291b29d1284784bc721c034ca1c2cb~mv2.png',
];
const H4MINI_IMAGES = [
  'https://static.wixstatic.com/media/0fa391_949dee3c5b9842539c8efd8cf74acd56~mv2.png/v1/fill/w_720,h_720,al_c,q_85,enc_auto/0fa391_949dee3c5b9842539c8efd8cf74acd56~mv2.png',
  'https://static.wixstatic.com/media/0fa391_145b721792374b60866b469e5148eb42~mv2.png/v1/fill/w_720,h_720,al_c,q_85,enc_auto/0fa391_145b721792374b60866b469e5148eb42~mv2.png',
];

const UL101_SPECS = [
  { label: 'UL101 Operating Frequency', value: '40 kHz ± 1.5 kHz' },
  { label: 'UL101 Detection Range', value: '150 feet (45 meters)' },
  { label: 'UL101 Battery Life', value: '45+ hours continuous (9 V alkaline)' },
  { label: 'UL101 Intrinsic Safety', value: 'ANSI/UL 913-88 Division 1 & 2 Certified' },
  { label: 'UL101 Warranty', value: '6-Year Parts & Labor' },
];

const UL101_FEATURES = [
  { title: 'Full UL101 Aviation Troubleshooter Kit (B00033)', description: 'Intrinsically safe UL101 receiver and UT2000 transmitter, acoustic and solid probe sets, concentrator set, industrial headset and the orange NANUK carrying case — the complete Boeing SPL-1473 tool.' },
  { title: 'Pinpoint, Then Confirm', description: 'Sweep a bay or cabin with the camera to see where ultrasound is coming from, then confirm the exact source by contact or airborne probe with the UL101 — two complementary methods in one kit.' },
];

const SHARED_APPLICATIONS = [
  'Cabin Pressurization Leak Checks - Image the fuselage, doors and windows for leak hotspots, then verify seals and fittings with the UL101 (AMM 20-10-79 / SPL-1473)',
  'Bleed Air, Pneumatic & Air-Cycle Systems - Visualize duct and clamp leaks from the ramp, then contact-check valves and fittings with the solid probes',
  'Hydraulic Bypass & Component Leaks - Detect internal bypass through contact ultrasound and image external leaks before they become AOG events',
  'Electrical & Partial Discharge Inspection - Scan ground power, static inverters and distribution panels for corona and arcing, then listen for intermittent wiring faults',
  'Pitot-Static, Oxygen & Tire Leak Checks - Fast airborne scans with the camera, confirmed at the fitting with the UL101',
];

export const COMBO_KITS = {
  b00700: {
    slug: 'b00700',
    partNumber: 'B00700',
    metaDescription: 'B00700 combo kit: the Boeing SPL-1473 UL101 Aviation Troubleshooter plus the FOTRIC H6 acoustic imaging camera. See the leak, then confirm it.',
    productName: 'UL101 Ultrasonic Inspection and Listening Kit',
    shortName: 'UL101 + H6 Combo Kit',
    tagline: 'UL101 Aviation Troubleshooter + FOTRIC H6 Acoustic Imaging Camera',
    boeingToolTag: 'SPL-1473 + COM-18702 (equivalent)',
    description:
      'The B00700 pairs the complete UL101 Aviation Troubleshooter kit — Boeing tool tag SPL-1473 — with the flagship FOTRIC H6 acoustic imaging camera. The H6 lets a technician see ultrasound across an entire wing root, cabin or electrical bay in seconds; the UL101 then confirms the exact leak, bypass or intermittent fault by contact or airborne probe. One P/N, one case plan, full coverage of both the handheld-probe and acoustic-camera methods the AMM calls out.',
    image: H6_IMAGES[0],
    images: [H6_IMAGES[0], UL101_IMAGE, H6_IMAGES[1]],
    imageContain: true,
    cameraId: 'h6',
    cameraPath: '/products/acoustic-cameras/h-series',
    features: [
      ...UL101_FEATURES,
      { title: 'FOTRIC H6 Acoustic Imaging Camera (F00061)', description: '162 MEMS digital microphones on a 6.6" spiral array, 2 – 100 kHz, 5" Gorilla Glass touchscreen and IP54 body — the most sensitive camera in the FOTRIC line for the smallest leaks and earliest partial discharge.' },
      { title: 'Dual LQ + PD Detection Modes', description: 'Leak quantification (LQ) estimates leak rate and cost on-device; partial discharge (PD) mode auto-classifies surface, floating and corona discharge with PRPD diagrams.' },
      { title: 'AnalyzIR Software & On-Device Reporting', description: 'Generate acoustic image reports on the camera and complete analysis in the AnalyzIR professional suite — ready for the maintenance record before you leave the aircraft.' },
    ],
    specifications: [
      { label: 'Kit Part Number', value: 'B00700' },
      { label: 'Includes', value: 'UL101 Aviation Troubleshooter kit (B00033) + FOTRIC H6 acoustic imaging camera (F00061)' },
      { label: 'Boeing Tool Tags', value: 'SPL-1473 (UL101) · COM-18702 equivalent (H6)' },
      ...UL101_SPECS,
      { label: 'H6 Microphone Array', value: '162 MEMS digital microphones, 6.6" spiral' },
      { label: 'H6 Frequency Range', value: '2 – 100 kHz' },
      { label: 'H6 Detection Modes', value: 'Leak (LQ) + Partial Discharge (PD)' },
      { label: 'H6 Display', value: '5" Gorilla Glass touchscreen' },
      { label: 'H6 Enclosure / Weight', value: 'IP54 · 1.3 kg' },
    ],
    applications: SHARED_APPLICATIONS,
  },
  b00705: {
    slug: 'b00705',
    partNumber: 'B00705',
    metaDescription: 'B00705 compact combo kit: the Boeing SPL-1473 UL101 Aviation Troubleshooter plus the 770 g FOTRIC H4mini acoustic imaging camera.',
    productName: 'UL101 Compact Ultrasonic Inspection and Imaging Kit',
    shortName: 'UL101 + H4mini Combo Kit',
    tagline: 'UL101 Aviation Troubleshooter + FOTRIC H4mini Acoustic Imaging Camera',
    boeingToolTag: 'SPL-1473 + COM-18702 (equivalent)',
    description:
      'The B00705 combines the complete UL101 Aviation Troubleshooter kit — Boeing tool tag SPL-1473 — with the lightweight FOTRIC H4mini acoustic imaging camera. At 770 g the H4mini is the one-handed camera for line maintenance: sweep a cabin, wheel well or bleed duct for leak hotspots in seconds, then confirm the exact source with the UL101. The compact way to put both the acoustic-camera and handheld-probe methods in one tool bag.',
    image: H4MINI_IMAGES[0],
    images: [H4MINI_IMAGES[0], UL101_IMAGE, H4MINI_IMAGES[1]],
    imageContain: true,
    cameraId: 'h4mini',
    cameraPath: '/products/acoustic-cameras/h4mini',
    features: [
      ...UL101_FEATURES,
      { title: 'FOTRIC H4mini Acoustic Imaging Camera (F00042)', description: '112 MEMS digital microphones, 2 – 100 kHz, 13 MP optical camera and a 3.5" IPS touch display in a 770 g, IP54 handheld built for one-handed ramp and hangar work.' },
      { title: 'Holographic Imaging Modes', description: 'Single-source, multi-source and holographic modes plus T-FFTD® acoustic image delay to catch intermittent leaks and transient discharges.' },
      { title: 'On-Device Reports', description: 'Capture holographic images, video and time-lapse and generate acoustic image reports directly on the camera — no laptop in the loop.' },
    ],
    specifications: [
      { label: 'Kit Part Number', value: 'B00705' },
      { label: 'Includes', value: 'UL101 Aviation Troubleshooter kit (B00033) + FOTRIC H4mini acoustic imaging camera (F00042)' },
      { label: 'Boeing Tool Tags', value: 'SPL-1473 (UL101) · COM-18702 equivalent (H4mini)' },
      ...UL101_SPECS,
      { label: 'H4mini Microphone Array', value: '112 MEMS digital microphones' },
      { label: 'H4mini Frequency Range', value: '2 – 100 kHz' },
      { label: 'H4mini Detection Modes', value: 'Leak mode (level display)' },
      { label: 'H4mini Display', value: '3.5" IPS LCD (640 × 480)' },
      { label: 'H4mini Enclosure / Weight', value: 'IP54 · 770 g' },
    ],
    applications: SHARED_APPLICATIONS,
  },
};

export const COMBO_KIT_LIST = Object.values(COMBO_KITS);
